import CaseCard from "./CaseCard"
import Carousel from '@itseasy21/react-elastic-carousel';

function CaseList(){

    const posts = [
        {
            id:'1234-qwer',
          title: 'Innovacion en materiales',
          href: '#',
          category: { name: 'Articulo', href: '#' },
          description:
            'Mantenemos la conviccion que la investigacion de nuevas tenologias que apoyen el crecimiento de la calidad de las telas, es indispensable para poder aumentar la confiabilidad y fibilidad con nuestros clientes.',
          date: 'Mar 16, 2020',
          datetime: '2020-03-16',
          imageUrl:
            'https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
          readingTime: '6 min',
          author: {
            name: 'Roel Aufderehar',
            href: '#',
            imageUrl:
              'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
          },
        },
        {
            id:'5678-asdf',
          title: 'Investigacion en la optimizacion de los procesos',
          href: '#',
          category: { name: 'Noticia', href: '#' },
          description:
            'Para confecciones Randol´s es indisensable siempre la optimizacion y mejora cotinua de sus procesos, esto con el fin de poder crecer como compañia y brindar la mejor calidad en la fabricacion de cada uno de nuestros prodctos.',
          date: 'Mar 10, 2020',
          datetime: '2020-03-10',
          imageUrl:
            'https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
          readingTime: '4 min',
          author: {
            name: 'Brenna Goyette',
            href: '#',
            imageUrl:
              'https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
          },
        },
        {
            id:'4321-zxcv',
          title: 'Mejora la experiencia de tus clientes',
          href: '#',
          category: { name: 'Mejora', href: '#' },
          description:
            'Bucamos encontrar un equilibrio entre lo que el cliente quier y lo que la empresa le ofrece, esto con el fin de poder dar a cada uno de ellos la mejor experiencia dentro de nuestra empresa.',
          date: 'Feb 12, 2020',
          datetime: '2020-02-12',
          imageUrl:
            'https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80',
          readingTime: '11 min',
          author: {
            name: 'Daniela Metz',
            href: '#',
            imageUrl:
              'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
          },
        },
      ]

    const  breakPoints = [
        { width: 1, itemsToShow: 1, itemsToScroll: 1 },
        { width: 1280, itemsToShow: 2, itemsToScroll: 2 },
        { width: 1750, itemsToShow: 3, itemsToScroll: 2 },
        // { width: 1450, itemsToShow: 5 },
        // { width: 1750, itemsToShow: 6 },
    ]

    return(
        <div className="relative  px-4 pt-16 pb-20 sm:px-6 lg:px-8  lg:pb-28">
        <div className="absolute inset-0">
          <div className="h-1/3 bg-white sm:h-2/3" />
        </div>
        <div className="relative mx-auto max-w-full">
          
            <Carousel
                itemsToScroll={3}
                itemsToShow={3}
                breakPoints={breakPoints}
                pagination={false}
                itemPadding={[0, 48]}
            >
          
                {posts.map((posts, index)=> 
                    <CaseCard index={index} posts={posts}/>
                )}
            </Carousel>
        </div>
      </div>
    )
}
export default CaseList